import { IssueDetail } from "models/issue";
import { Flex } from "@chakra-ui/react";
import { ResolutionInfo } from "models/resolutions";
import GreenStatusButton from "components/Status/GreenStatusButton";
import { FiCheckCircle } from "react-icons/fi";
import { RedirectToConnectSlackGrayTableButton } from "features/Issues/Components/Button/SlackResolutionButtons";
import { missingAttributeValue } from "./MissingAttribute";

export function missingMessageServiceIssueType(_: IssueDetail) {
  return "Slack Not Connected";
}

function IssueModalInputFields({ issue }: { issue: IssueDetail }) {
  const value = missingAttributeValue(issue);
  return (
    <Flex direction="column" gap="1">
      <RedirectToConnectSlackGrayTableButton />
      {value && <GreenStatusButton icon={FiCheckCircle}>Slack Connected</GreenStatusButton>}
    </Flex>
  );
}

export function missingMessageServiceValue(issue: IssueDetail) {
  return issue?.company?.messageService?.serviceCompanyId;
}

export function missingMessageServiceResolution(_1: IssueDetail): ResolutionInfo {
  return ({
    issueType: "missing_message_service",
    tagText: "Slack not connected",
    title: "Slack is not connected to Camino",
    additionalContext: `Slack is not connected to Camino, and an action requires this. Please go to the integrations sidebar and connect Slack.`,
    inputComponent: IssueModalInputFields,
  });
}
